import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { errMsg, inp } from "@/components/attendance/ui";

export default function PlanPrices() {
  const [plans, setPlans] = useState(null);
  const load = () => api.get("/admin/service-plans").then((r) => setPlans(r.data)).catch(() => toast.error("Could not load prices"));
  useEffect(() => { load(); }, []);
  const save = async (p) => {
    try { await api.put(`/admin/service-plans/${p.id}`, { name: p.name, price_monthly: Number(p.price_monthly), price_annual: Number(p.price_annual), active: p.active }); toast.success(`${p.name} saved`); load(); }
    catch (e) { toast.error(errMsg(e, "Save failed")); }
  };
  const edit = (id, k, v) => setPlans({ ...plans, plans: plans.plans.map((p) => (p.id === id ? { ...p, [k]: v } : p)) });
  if (!plans) return <Loader2 className="animate-spin text-[#D4AF37]" />;
  return (
    <section data-testid="plan-prices">
      <div className="flex flex-wrap justify-between items-baseline gap-2 mb-3">
        <h3 className="font-serif-display text-2xl text-white">Subscription prices</h3>
        <span className="text-xs text-neutral-400" data-testid="att-admin-billing-mode">Billing mode: <span className="text-[#D4AF37]">{plans.billing_mode}</span></span>
      </div>
      <p className="text-xs text-neutral-500 mb-4">Changes apply to new subscriptions (a new Stripe price is created; existing subscribers keep their price). After changing a price, run the billing readiness check and create prices again before going live.</p>
      <div className="space-y-2">
        {plans.plans.map((p) => (
          <div key={p.id} className="grid grid-cols-12 gap-3 items-center luxury-card rounded-lg p-3" data-testid={`att-plan-${p.id}`}>
            <input className={`${inp} col-span-12 md:col-span-5`} value={p.name} onChange={(e) => edit(p.id, "name", e.target.value)} aria-label="Plan name" data-testid={`att-plan-${p.id}-name`} />
            <label className="col-span-5 md:col-span-3 text-xs text-neutral-400 flex items-center gap-2">£/mo<input type="number" step="0.01" className={inp} data-testid={`att-plan-${p.id}-monthly`} value={p.price_monthly} onChange={(e) => edit(p.id, "price_monthly", e.target.value)} /></label>
            <label className="col-span-5 md:col-span-3 text-xs text-neutral-400 flex items-center gap-2">£/yr<input type="number" step="0.01" className={inp} data-testid={`att-plan-${p.id}-annual`} value={p.price_annual} onChange={(e) => edit(p.id, "price_annual", e.target.value)} /></label>
            <button onClick={() => save(p)} data-testid={`att-plan-${p.id}-save`} className="col-span-2 md:col-span-1 p-2 text-neutral-300 hover:text-[#D4AF37]" title="Save"><Save size={15} /></button>
          </div>
        ))}
      </div>
    </section>
  );
}
